/**
 * 环境配置管理
 */

// 获取环境变量的辅助函数
const getEnv = (key, defaultValue = "") => {
  return process.env[key] || defaultValue;
};

// 环境配置
export const config = {
  // 基础配置
  NODE_ENV: getEnv("NODE_ENV", "development"),

  // 应用配置
  APP_TITLE: getEnv("VUE_APP_TITLE", "单词记忆应用"),
  DEBUG: getEnv("VUE_APP_DEBUG", "false") === "true",

  // API 配置
  API_BASE_URL: getEnv("VUE_APP_API_BASE_URL", "https://www.techbvocabulary.com/techb/api"),
  
  // 音频文件配置
  VOICE_URL: getEnv("VUE_APP_VOICE_URL", "https://www.techbvocabulary.com/techb"),

  // 功能开关
  ENABLE_CONSOLE_LOG: getEnv("VUE_APP_ENABLE_CONSOLE_LOG", "true") === "true",
  ENABLE_ERROR_REPORTING:
    getEnv("VUE_APP_ENABLE_ERROR_REPORTING", "false") === "true",
};

// 环境判断
export const isDevelopment = config.NODE_ENV === "development";
export const isProduction = config.NODE_ENV === "production";
export const isTest = config.NODE_ENV === "test";

// 打印当前配置（仅在开发环境）
if (isDevelopment && config.DEBUG) {
  console.log("🔧 当前环境配置:", config);
}

export default config;
